
import { Injectable } from '@angular/core';

@Injectable()
export class ErrorMessages {
    constructor() {

    }
    public DUPLICATE_ASSOCIATE_PROFILE_NAME = "Selected profile already associated."
}